<script setup>
import { ref } from 'vue'

const openIndex = ref(null)

function toggle(i) {
  openIndex.value = openIndex.value === i ? null : i
}
const faqItems = [
  {
    question: 'Что такое MyVPS?',
    answer:
      'MyVPS — это сервис, обеспечивающий быстрый и анонимный доступ к интернету через собственные VPS‑серверы.',
  },
  {
    question: 'Как включить MyVPS?',
    answer:
      'Скачайте и установите наше официальное приложение через Google Play и запустите VPS-сервер в два клика',
  },
  {
    question: 'Где скачать приложение?',
    answer:
      'Приложение доступно в Google Play. Перейти на страницу скачивания можно, нажав на синюю кнопку внизу.',
  },
  {
    question: 'Если мне не понравится ваш сервис, могу ли я отказаться от подписки?',
    answer:
      'Да, конечно! Отмена подписки доступна внутри приложения в меню «Управление подпиской». Отключить её можно в любой момент.',
  },
  {
    question: 'Можно ли пользоваться MyVPS на нескольких устройствах?',
    answer:
      'Да, конечно! На всех тарифах доступно подключение 2 устройств дополнительно.',
  },
  {
    question: 'Можно ли изменить тариф?',
    answer:
      'Да, конечно! Смена тарифа доступна внутри приложения в меню «Управление подпиской».',
  },
]
</script>

<template>
  <section class="faq-section">
    <h2 class="section-title">FAQ</h2>
    <ul class="faq-list">
      <li v-for="(item, i) in faqItems" :key="i" class="faq-item">
        <div class="faq-summary" @click="toggle(i)">
          {{ item.question }}
          <span class="faq-arrow" :class="{ open: openIndex === i }">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#0089ff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>
        <transition name="faq-transition">
          <div v-show="openIndex === i" class="faq-answer">
            <p>{{ item.answer }}</p>
          </div>
        </transition>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.faq-section {
  width: 100%;
  background: white;
  margin-top: -50px;
  padding: 32px 24px;
  min-height: calc(100vh - var(--header-h) - var(--footer-h));
  padding-bottom: var(--footer-h);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.faq-list {
  max-width: 700px;
  margin: 0 auto;
  padding: 0;
  list-style: none;
}
.faq-item {
  margin-bottom: 16px;
  background-color: #fff;
  overflow: hidden;
  border-bottom: 1px solid #eee;
}

.faq-summary {
  cursor: pointer;
  font-family: 'Play', sans-serif;
  padding: 8px 20px;
  font-size: 20px;
  font-weight: 500;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  color: #0089ff;
}

.faq-arrow {
  transition: transform 0.3s ease;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.faq-arrow.open {
  transform: rotate(180deg);
}

.faq-answer {
  padding: 12px 20px 20px;
  color: #333;
  overflow: hidden;
}

.faq-transition-enter-active,
.faq-transition-leave-active {
  transition: all 0.35s ease;
}
.faq-transition-enter-from,
.faq-transition-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.faq-transition-enter-to,
.faq-transition-leave-from {
  max-height: 500px;
  opacity: 1;
}

</style>
